import { Popover, PopoverProps } from 'antd';

type Props = PopoverProps;

export default function PTPopover(props: Props) {
  return <Popover {...props} />;
}
